import { useSortBy, useTable, usePagination, useFilters, useGlobalFilter, useAsyncDebounce, useExpanded } from 'react-table'
import React, { useEffect } from 'react'
import "../../../../styleSheets/sass/components/manageProductHistory.scss"
import makeData from './makeData'
import Button from "../button/Button"
import "../../../../styleSheets/sass/components/prodHistoryTable/table.scss"
import { Pagination } from 'semantic-ui-react'
import { Icon } from 'semantic-ui-react'
import {matchSorter} from 'match-sorter'
import _ from "lodash"


function fuzzyTextFilterFn(rows, id, filterValue) {
  return matchSorter(rows, filterValue, { keys: [row => row.values[id]] })
}

fuzzyTextFilterFn.autoRemove = val => !val

function Table({ columns, data, method, selectedRowId, pageNumberMethod, totalPages, currentPage, searchMethod, manualPagination ,reconCheck, importerList}) {

    const filterTypes = React.useMemo(
      () => ({
        // Add a new fuzzyTextFilterFn filter type.
        fuzzyText: fuzzyTextFilterFn,
        // Or, override the default text filter to use
        // "startWith"
        text: (rows, id, filterValue) => {
          return rows.filter(row => {
            const rowValue = row.values[id]
            return rowValue !== undefined
              ? String(rowValue)
                  .toLowerCase()
                  .startsWith(String(filterValue).toLowerCase())
              : true
          })
        },
      }),
      []
    )

    const defaultColumn = React.useMemo(
      () => ({
        // Let's set up our default Filter UI
        Filter: DefaultColumnFilter,
      }),
      []
    )

    // Use the state and functions returned from useTable to build your UI
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
      page, // Instead of using 'rows', we'll use page,
      // which has only the rows for the active page
  
      // The rest of these things are super handy, too ;)
      canPreviousPage,
      canNextPage,
      pageOptions,
      pageCount,
      gotoPage,
      nextPage,
      previousPage,
      visibleColumns,
      setPageSize,
      preGlobalFilteredRows,
      state: { pageIndex, pageSize },
      state,
      setGlobalFilter
    } = useTable(
      {
        columns,
        data,
        initialState: { pageIndex: 0, pageSize: manualPagination ? 100 : 10 },
        defaultColumn, 
        filterTypes,
      },
      useFilters, // useFilters!
      useGlobalFilter, // useGlobalFilter!
      useSortBy,
      usePagination,
    )
    const [onFirstPage, setOnFirstPage] = React.useState(false)
    const [onLastPage, setOnLastPage] = React.useState(false)
    useEffect(() => {
      if(currentPage === 1){
        setOnFirstPage(true);
      }
      else{
        setOnFirstPage(false);
      }

      if(currentPage === totalPages){
        setOnLastPage(true);
      }
      else{
        setOnLastPage(false);
      }
    })

    function onlySpaces(str) {
      
      return /^\s*$/.test(str);
    }

    const [searchFilters, setSearchFilters] = React.useState({
      "productDescription": "",
      "HTS": "",
      "productTag": "",
      "customerId": "",
      "customerName": "",
      "originCountry": "",
      "manufacturerName": "",
      "lastModified": ""
    })

    const [searchStatus, setSearchStatus] = React.useState({
      "productDescription": false,
      "HTS": false,
      "productTag": false,
      "customerId": false,
      "customerName": false,
      "originCountry": false,
      "manufacturerName": false,
      "lastModified": false
    }) 
    const [clearSearchDisable, setClearSearchDisable] = React.useState(true);

    let searchStatusEval = () => {
      if(searchStatus["productDescription"] || searchStatus["HTS"] || searchStatus["productTag"] || searchStatus["customerId"] || searchStatus["originCountry"] || searchStatus["manufacturerName"] || searchStatus["lastModified"]){
        setClearSearchDisable(false);
        return true;
      }
      else{
        setClearSearchDisable(true);
        return false;
      }
    }
    useEffect(() => {
      if(searchStatus["productDescription"] || searchStatus["HTS"] || searchStatus["productTag"] || searchStatus["customerId"] || searchStatus["customerName"] || searchStatus["originCountry"] || searchStatus["manufacturerName"] || searchStatus["lastModified"]){
        setClearSearchDisable(true);
      }
      else{
        setClearSearchDisable(false);
      }

    }, [searchStatus])
    
    let debounced =  _.debounce((searchFilters, searchApiFlag) => {
      searchMethod(searchFilters, searchApiFlag, 1);
    }, 1000)
    // const firstPageRows = rows.slice(0, 10)

    

         

    // Render the UI for your table
    return (
      <>
      <section className="react-table-wrapper" style={{width:"100%"}}>
        <div style={{textAlign: "right"}}>
          {
          manualPagination && <Button className="newButton primaryBtn btnType1 mediumBtn reset-search-filter" disabled={!clearSearchDisable} onClick={() => {
            setSearchStatus({
              "productDescription": false,
              "HTS": false,
              "productTag": false,
              "customerId": false,
              "customerName": false,
              "originCountry": false,
              "manufacturerName": false,
              "lastModified": false
            });
            setSearchFilters({
              "productDescription": "",
              "HTS": "",
              "productTag": "",
              "customerId": "",
              "customerName": "",
              "originCountry": "",
              "manufacturerName": "",
              "lastModified": ""
            });
            searchMethod(searchFilters, false, 1);
          }} type="button">
          <Icon name='sync alternate' color="white"/> Clear Search
          </Button>}
        </div>
        <div className="prod-hist-table">
          <table className="react-table" {...getTableProps()} style={{width: "100%"}}>
              <thead>
                {headerGroups.map(headerGroup => (
                  <>
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                      <th className='fixed table-header' style={{whiteSpace: 'nowrap'}} >
                        <div {...column.getHeaderProps(column.getSortByToggleProps())}>
                          {column.render('Header')}
                          <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? <Icon name='sort down' />
                              : <Icon name='sort up' />
                            : ''}
                          
                          </span>
                        </div>
                        <div className="tableFilters">
                          {manualPagination ? <input
                          type="text"
                          name={column.render('Name')}
                          value={searchFilters[column.render('Name')]}
                          onChange={e => {
                            let newSearchFilter = {...searchFilters}
                            
                            let newSearchStatus = {...searchStatus}
                            if(!onlySpaces(e.target.value) || e.target.value === ""){
                              newSearchFilter[column.render('Name')] = e.target.value
                            }
                            if(!onlySpaces(e.target.value)){
                              newSearchStatus[column.render('Name')] = true; 
                            }
                            else{
                              newSearchStatus[column.render('Name')] = false;
                            }
                            setSearchStatus(newSearchStatus);
                            setSearchFilters(newSearchFilter);
                            if(clearSearchDisable){
                              setClearSearchDisable(false);
                            }
                            else{
                              setClearSearchDisable(true);
                            }
                          }}
                          onKeyPress={(ev) => {

                            if (ev.key === "Enter" || ev.which === 13) {
                              let searchApiFlag = clearSearchDisable;
                              debounced(searchFilters ,searchApiFlag)
                            }
                          }}

                          placeholder={`Search records...`}/> : 
                          <div className="tableFilters">{column.canFilter ? column.render('Filter') : null}</div>}
                        </div>
                      </th>
                    ))}
                  </tr>
                  <tr className="searchCountRow">
                    <th
                      colSpan={visibleColumns.length}
                      style={{
                        textAlign: 'left',
                      }}
                    >
                      <GlobalFilter
                        preGlobalFilteredRows={preGlobalFilteredRows}
                        globalFilter={state.globalFilter}
                        setGlobalFilter={setGlobalFilter}
                      /> 
                    </th>
                  </tr>
                  </>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                  prepareRow(row)
                  return (
                      <tr {...row.getRowProps()} className={selectedRowId === row.id ? "selected selectable-row" : "selectable-row"} onClick={() => {
                        method(row.original, row.id)
                      }}>
                        {row.cells.map((cell, i) => {
                          if(cell?.column?.Header === 'Importer'){
                            const importerCode = cell.value
                            console.log("importerList:", importerList, importerCode)
                            const importer = importerList.filter((item) => item.customerCode === importerCode)[0];
                            if(importer && importer?.companyName){cell.row.values.importerCode = importer?.companyName}
                          }
                          if(cell.row.values.lastModified)
                          {
                            cell.row.values.lastModified = cell.row.values.lastModified.split('T')[0];
                          }
                          return <td key={i} {...cell.getCellProps()}>{cell.render('Cell')}</td>
                        })}
                      </tr> 
                  )
                })}
              </tbody>
          </table>
        </div>


        {/* <Pagination defaultActivePage={5} totalPages={10} /> */}

        { manualPagination ? (totalPages > 1 && <div className="paginationWrapper">
          <div className="ui pagination menu">
            <a className="item" onClick={() => {let searchApiFlag = clearSearchDisable; pageNumberMethod(1, searchApiFlag, searchFilters)}} disabled={onFirstPage}>
              <Icon name='angle double left' />
            </a>{' '}
            <a className="item" onClick={() => {let searchApiFlag = clearSearchDisable; pageNumberMethod(currentPage - 1, searchApiFlag, searchFilters)}} disabled={onFirstPage}>
              <Icon name='angle left' />
            </a>{' '}
            <span className="pageCountDisplay">
                Page{' '}
                {currentPage} of {totalPages}
            </span>
            <a className="item addLeftBorder" onClick={() => {let searchApiFlag = clearSearchDisable; pageNumberMethod(currentPage + 1, searchApiFlag, searchFilters)}} disabled={onLastPage}>
              <Icon name='angle right' />
            </a>{' '}
            <a className="item" onClick={() => {let searchApiFlag = clearSearchDisable; pageNumberMethod(totalPages, searchApiFlag, searchFilters)}} disabled={onLastPage}>
              <Icon name='angle double right' />
            </a>{' '}
          
          </div>
        </div>) : 
        (<div className="paginationWrapper">
        <div className="ui pagination menu">
        <a className="item first-page" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            <Icon name='angle double left' />
          </a>{' '}
          <a className="item previous-page" onClick={() => previousPage()} disabled={!canPreviousPage}>
            <Icon name='angle left' />
          </a>{' '}
          <span className="pageCountDisplay">
              Page{' '}
              {pageIndex + 1} of {pageOptions.length}
          </span>
          <a className="item addLeftBorder next-page" onClick={() => nextPage()} disabled={!canNextPage}>
            <Icon name='angle right' />
          </a>{' '}
          <a className="item last-page" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
            <Icon name='angle double right' />
          </a>{' '}
        
        </div>
      </div>)}

      </section>
      </>
    )
  }

  // Define a default UI for filtering
  function GlobalFilter({
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
  }) {
    const count = preGlobalFilteredRows.length
    const [value, setValue] = React.useState(globalFilter)
    const onChange = useAsyncDebounce(value => {
      setGlobalFilter(value || undefined)
    }, 200)

    return (
      <span>
        Search:{' '}
        <input
          value={value || ""}
          onChange={e => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
          placeholder={`${count} records...`}
          style={{
            fontSize: '1.1rem',
            border: '0',
          }}
        />
      </span>
    )
  }

  // Define a default UI for filtering
  function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
  }) {
    const count = preFilteredRows.length

    return (
      <input
        type="text"
        value={filterValue || ''}
        onChange={e => {
          setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
        }}
        placeholder={`Search ${count} records...`}
      />
    )
  }



  function TableApp({ columns, data, method, selectedRowId, pageNumberMethod, pageNumber, totalPages, searchMethod, manualPagination,reconCheck, importerList }) {
    const propColumns = React.useMemo(
      () => columns,
      []
    )
  
    const propData = data
    
    return (
      <>
        <Table manualPagination={manualPagination} searchMethod={searchMethod} currentPage={pageNumber} totalPages={totalPages} columns={propColumns} data={propData} method={method} selectedRowId={selectedRowId} pageNumberMethod={pageNumberMethod} reconCheck={reconCheck} importerList={importerList}/>

        
      </>
    )
  }
  
export default TableApp; 